import { Box, Typography } from '@mui/material';
import { PanelBox } from 'components/PanelBox';
import { VideoCard } from 'components/VideoCard';
import { DragNDropList } from 'components/DragNDropList';
import { VideoOrSerieModal } from 'components/TableWithCheck/VideoOrSerieModal';
import { HOME_SHOW_KEY_ID, thumbAdornment } from 'constants/homeApp';
import { getImageURL } from 'utils/tableListFormat';
import { useHomeShow } from './useHomeShow';
import { Loaders } from 'components/Loader';
import { EditModalButton } from './EditModalButton';
import { DeleteModalButton } from 'components/Modal/DeleteModalButton';
import { useEffect } from 'react';
import { useLoadingStore } from 'store/loadingStore';
import { AppListSummary } from '../AppListSummary';
import { useTableSelectedList } from 'hooks/useTableSelectedList';

export const HomeShow = () => {
  const { loading, maxItemsLimitExeeded, getHomeShowData, resetHomeShowData } =
    useHomeShow();
  const homeShowList = useTableSelectedList(HOME_SHOW_KEY_ID);

  const savingHomeApp = useLoadingStore(state => state.savingHomeApp);

  useEffect(() => {
    getHomeShowData();
  }, [getHomeShowData]);

  useEffect(() => {
    return () => {
      resetHomeShowData();
    };
  }, [resetHomeShowData]);

  return (
    <PanelBox
      id="home-show"
      title="Home show"
      description="Carrossel principal"
      count={{
        selectedLength: homeShowList?.selectedItems?.length,
        maxLength: 10,
      }}>
      <AppListSummary list={homeShowList?.selectedItems} />
      <Box
        sx={{
          backgroundColor: '#F9FAFB',
          color: '#475467',
          display: 'grid',
          gridTemplateColumns: '218px auto',
          alignItems: 'center',
          padding: '13px 24px',
        }}>
        <Typography variant="body2" fontWeight={500}>
          Thumbnail
        </Typography>
        <Typography variant="body2" fontWeight={500}>
          Título
        </Typography>
      </Box>
      {loading && <Loaders.TableInfo sx={{ padding: 100 }} />}
      <DragNDropList
        onChange={value => {
          homeShowList.setSelectedItems(
            value.map((i, index) => ({
              ...i.data,
              sortNumber: index + 1,
            }))
          );
        }}
        items={
          homeShowList?.selectedItems?.map(i => ({
            id: i.id,
            data: i,
            component: (
              <VideoCard.Root divider key={i} disabled={savingHomeApp}>
                <VideoCard.Image
                  variant="square"
                  image={getImageURL(i)}
                  size="small">
                  <VideoCard.CornerAdornment
                    name={thumbAdornment[i?.type || i?.contentType || 'VIDEO']}
                  />
                </VideoCard.Image>
                <VideoCard.DescriptionDetail {...i} />
                <VideoCard.ActionsContainer>
                  <DeleteModalButton
                    itemName={i.title}
                    itemSubject="Home show"
                    disabled={savingHomeApp}
                    onDelete={() => homeShowList.deleteSelectedItemsById(i.id)}
                  />
                  <VideoCard.ActionButton
                    disabled={savingHomeApp}
                    action="move"
                    onClick={() => {}}
                  />
                  <EditModalButton data={i} disabled={savingHomeApp} />
                </VideoCard.ActionsContainer>
              </VideoCard.Root>
            ),
          })) || []
        }
      />
      <Box display="grid" justifyContent="end">
        <VideoOrSerieModal
          allowCollections
          disabled={loading || savingHomeApp}
          itemName="Home show"
          listId={HOME_SHOW_KEY_ID}
          limitExceeded={maxItemsLimitExeeded}
          count={{
            selectedLength: homeShowList?.selectedItems?.length,
            maxLength: 10,
          }}
        />
      </Box>
    </PanelBox>
  );
};
